import { createRouter, createWebHistory } from 'vue-router'
import ProductCatalog from '@/components/Catalog.vue'
import CartPage from '@/components/CartPage.vue'
import ProductPreviewPage from '@/components/ProductPreviewPage.vue'

const routes = [
  {
    path: '/',
    name: 'catalog',
    component: ProductCatalog
  },
  {
    path: '/cart',
    name: 'cart',
    component: CartPage
  },
  {
    path: '/p/:id',
    name: 'product',
    component: ProductPreviewPage,
    props: route => ({ productId: route.params.id })
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
